import { useEffect, useState } from 'react';

import { getPaymentPlanInfo } from '../api/customerCards/api';
import { SPLIT_MIN_DAYS_BEFORE_TRIP } from '../api/pelecardUtils/pelecardInstallments';

/**
 * tripDate/fullPaymentWindowDays for a travel file, the same numbers a saved-card
 * charge resolves them to (see SavedCardPicker) — used by the NEW-card (Masleka
 * iframe) flow to offer the same instalment/credit-deal plan a saved-card charge
 * would, without requiring `customer_card:view`.
 */
const usePaymentPlanInfo = (travelFileId?: number | string | null) => {
    const [tripDate, setTripDate] = useState<string | null>(null);
    const [fullPaymentWindowDays, setFullPaymentWindowDays] = useState(SPLIT_MIN_DAYS_BEFORE_TRIP);

    useEffect(() => {
        if (!travelFileId) {
            setTripDate(null);
            setFullPaymentWindowDays(SPLIT_MIN_DAYS_BEFORE_TRIP);
            return;
        }
        let cancelled = false;
        getPaymentPlanInfo(travelFileId)
            .then((info) => {
                if (cancelled) return;
                setTripDate(info.tripDate);
                setFullPaymentWindowDays(info.fullPaymentWindowDays);
            })
            .catch(() => {
                if (cancelled) return;
                setTripDate(null);
                setFullPaymentWindowDays(SPLIT_MIN_DAYS_BEFORE_TRIP);
            });
        return () => {
            cancelled = true;
        };
    }, [travelFileId]);

    return { tripDate, fullPaymentWindowDays };
};

export default usePaymentPlanInfo;
